import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Image } from 'components/Image/Image';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import React from 'react';
import { useFlag } from 'hook/flag.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { BUILDER_2_UNENROLLED_OVERVIEW } from 'types/morph.pagePosition.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import classnames from 'classnames';

const ShowBullets = props => {
  const { bullets } = props;

  return bullets.map((bullet, index) => {
    return (
      <FlexContainer key={`builder-module-bullet ${index}`}>
        <Image
          imgClass={'sesamecashEnrollCheckIcon'}
          className={'width22px height24px'}
        />
        <Label type={'Body-2'}>{bullet}</Label>
      </FlexContainer>
    );
  });
};

const CreditBuilderModuleController = props => {
  const { history, modulePosition, eventHandler, isTwoModules } = props;
  const cb20GaWebFlag = useFlag('cb2_0_ga_web');
  const { scoreBelow650Config } =
    cb20GaWebFlag?.config?.module_unenrolled_user ?? {};
  const goToCash = () => {
    eventHandler?.(CLICK, {
      'Click Type': 'Learn More',
    });
    history.push('/cash');
  };

  const trackingAtr = getViewModuleTrackingAttributes(
    BUILDER_2_UNENROLLED_OVERVIEW,
    modulePosition,
  );

  const seenPixel = useSeenModulePixel(trackingAtr);

  const creditBuilderClass = classnames(
    'padTB26 m-padLR16 grayShadow16 border-rad8px width100 flex-1 system_neutral_n000',
    {
      'padL32 padR44': !isTwoModules,
      padLR16: isTwoModules,
    },
  );

  const containerClass = classnames(
    'm-justify-between items-align-center width100 m-flex-column',
    {
      'flex-column': isTwoModules,
      'justify-between': !isTwoModules,
    },
  );

  const imageDesktopClass = classnames('items-align-center m-padR0', {
    padR30: !isTwoModules,
    padR0: isTwoModules,
  });

  const flexInfoClass = classnames('flex-column m-gap-0', {
    'gap-6': !isTwoModules,
    'gap-0': isTwoModules,
  });

  const bulletClass = classnames(
    'flex-column m-padTB20 system_neutral_n400_text',
    {
      'padT16 padB14': isTwoModules,
    },
  );

  return (
    <>
      <FlexContainer className={creditBuilderClass}>
        {seenPixel}
        <FlexContainer className={containerClass}>
          <FlexContainer>
            <FlexContainer className={imageDesktopClass}>
              {!isTwoModules && (
                <Image
                  imgClass={'sesamecashEnrollImage'}
                  className={'width78px height84px m-hide'}
                />
              )}
            </FlexContainer>
            <FlexContainer className={flexInfoClass}>
              <Label
                type={'Subtitle-1'}
                className={'text-center system_neutral_n400_text'}
              >
                {scoreBelow650Config?.title}
              </Label>
              <FlexContainer className={'justify-between items-align-center'}>
                <FlexContainer className={bulletClass}>
                  <ShowBullets bullets={scoreBelow650Config?.bullets} />
                </FlexContainer>
                {isTwoModules && (
                  <Image
                    imgClass={'sesamecashEnrollImage'}
                    className={'width78px height84px m-hide'}
                  />
                )}
                <Image
                  imgClass={'sesamecashEnrollImage'}
                  className={'width78px height84px d-hide'}
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
          <FlexContainer
            className={'height44px justify-center width250px t-width100'}
          >
            <Button
              mrphType={'primary'}
              rounded
              className={'m-borderNone borderRadius100 width100'}
              onClick={goToCash}
            >
              {scoreBelow650Config?.ctaText}
            </Button>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default CreditBuilderModuleController;
